import ItemView from "../pages/ItemView"
import ListView from '../pages/ListView'
import AboutView from '../pages/AboutView'
import SearchView from '../pages/SearchView'
import { Switch, Route } from "react-router-dom"
import { useState, useEffect } from 'react'
import { RoutingPath } from '../routes/RoutingPath'

function Content(props) {
    const [chosenMonth, setChosenMonth] = useState(99)
    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    // Get all items
    useEffect(() => {
        setLoading(true)
        setError(false)
        let mounted = true
        if (mounted) getItems()
        return () => mounted = false;
    }, [])

    const getItems = async () => {
        try {
            let response = await fetch('/database.json')
            response = await response.json()
            setLoading(false)
            setData(response)
        } catch (error) {
            setLoading(false)
            setError(true)
        }
    }

    return (
        <>
            {!loading ?
                <>
                {!error ?
                    <Switch>
                    <Route exact path={RoutingPath.about}>
                        <AboutView />
                    </Route>
                    <Route exact path={RoutingPath.search}>
                        <SearchView 
                            data={data} 
                            searchValue={props.searchValue} 
                        />
                    </Route>
                    <Route exact path={RoutingPath.singleItem}>
                        <ItemView 
                            data={data}
                        />
                    </Route>
                    <Route path={RoutingPath.home}>
                        <ListView
                            data={data}
                            chosenMonth={chosenMonth}
                            setChosenMonth={setChosenMonth}
                            showEuropean={props.showEuropean}
                            filterCategory={props.filterCategory}
                        />
                    </Route>
                    </Switch>
                :
                    <p>Kunde inte ansluta till databasen. Vänligen försök igen senare.</p>
                }
                </>
            :
                <p>Laddar... Vänligen vänta...</p>
            }
        </>
    )
}

export default Content